import { useState, useCallback, useEffect } from 'react';
import Observer from '@researchgate/react-intersection-observer';
import { useTracking } from 'react-tracking';
import { IntersectionBox } from './styled';

interface Props {
  subject: string;
  properties: any;
}

const ScrollTracking = ({ subject, properties }: Props) => {
  const [isTracked, setIsTracked] = useState(false);
  const { trackEvent } = useTracking();
  const handleObserverChanged = useCallback(
    ({ isIntersecting }) => {
      if (isIntersecting && !isTracked) {
        trackEvent({
          type: 'track',
          action: 'scroll',
          subject,
          data: {
            ...properties,
          },
        });
        setIsTracked(true);
      }
    },
    [isTracked, subject]
  );
  useEffect(() => {
    if (isTracked) {
      setIsTracked(false);
    }
  }, [properties]);
  return (
    <Observer onChange={handleObserverChanged}>
      <IntersectionBox />
    </Observer>
  );
};

export default ScrollTracking;
